module.exports = __webpack_public_path__ + "img/logo_paracatu.1a8446cf.png";